import React from "react";


const Engine = () => {
    return(
        <div className="skills__content">
                <h3 className="skills__title">Engines</h3>

                <div className="skills__box">
                    <div className="skills group">
                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">Unreal</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">Unity</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>

                        <div className="skills__data">
                            <i className="bx bx-badge-check"></i>

                            <div>
                                <h3 className="skills__name">Godot</h3>
                                    <span className="skills__level">Intermediate</span>

                            </div>
                        </div>

                    </div>

                </div>
        </div>
    )
}

export default Engine